import styled from 'styled-components';

export const ResponsiveColumn = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;

  @media (min-width: 1051px) {
    padding-top: 24px;
    padding-bottom: 24px;
  }
`;

export const LeftColumn = styled(ResponsiveColumn)`
  width: 36%;
  border-right: 1px solid ${({ theme }) => theme.colors.black10};
  padding-right: 36px;

  @media (max-width: 1050px) {
    width: 100%;
    border-right: none;
    padding-right: 0;
  }
`;

export const RightColumn = styled(ResponsiveColumn)`
  flex: 1;
`;
